import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import './RadioInput.scss';

export const RadioInput = (props) => {
  const { className, groupName, label, options, onChange, defaultInterval } =
    props;

  const classes = classNames('lanl-radio-input', className);

  return (
    <div className={classes}>
      <fieldset>
        <legend>{label}</legend>
        <div className='toggle'>
          {options.map(({ id, label, value, disabled, defaultInterval }) => (
            <React.Fragment key={`input-${id}-${disabled}-${defaultInterval}`}>
              <input
                type='radio'
                name={groupName}
                className='radio-btn'
                id={id}
                value={value}
                defaultChecked={defaultInterval === value}
                disabled={disabled}
                onChange={(e) => onChange(e, value)}
              />
              <label htmlFor={id}>{label}</label>
            </React.Fragment>
          ))}
        </div>
      </fieldset>
    </div>
  );
};

RadioInput.defaultProps = {
  options: [],
};

RadioInput.propTypes = {
  groupName: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  options: PropTypes.array.isRequired,
  className: PropTypes.string,
};

export default RadioInput;
